import {
  ArrowRightIcon,
  BookOpenIcon,
  ShieldPlusIcon,
  TrendingUpIcon,
} from 'lucide-react'

import { useEmbeddedOnboarding } from 'components/hooks/employer_onboarding/useEmbeddedOnboarding'
import { useOnboardingStep } from 'components/hooks/employer_onboarding/useOnboardingStep'
import { Button, usePageTitle } from 'slab'

import { CenteredLayout } from '../CenteredLayout'
import { ContainerList } from '../ContainerList'
import { useEmployer } from '../EmployerProvider'

export function SetupIntroPage () {
  usePageTitle('Get started')

  const { isEmbedded } = useEmbeddedOnboarding()
  const { employer } = useEmployer()
  const { navigateToNextStep } = useOnboardingStep()

  function getGreeting () {
    const greeting = isEmbedded ? 'Let’s get started' : 'Great to meet you'
    // Could use embedded user name if isEmbedded
    const firstName = employer?.current_admin?.first_name
    const nameText = firstName ? `, ${firstName}` : ''

    return `${greeting}${nameText}!`
  }

  function getEmployerName () {
    if (employer?.name) {
      return employer.name
    }

    return 'you'
  }

  return (
    <CenteredLayout displaySupportLink>
      <CenteredLayout.Header
        heading={getGreeting()}
        subheading={`Let’s walk through how Thatch could work for ${getEmployerName()}. We’ll build a tailored recommendation based on your team and goals.`}
      />
      <div className='mb-10'>
        <h2 className='heading-sm-regular mb-4 text-center'>
          Together, we'll:
        </h2>
        <ContainerList>
          <ContainerList.Item icon={BookOpenIcon} heading='Understand what’s important to you and your team' />
          <ContainerList.Item icon={ShieldPlusIcon} heading='Gather some basic information about your company & current benefits' />
          <ContainerList.Item icon={TrendingUpIcon} heading='Walk through your recommended Thatch benefits strategy' />
        </ContainerList>
      </div>
      <CenteredLayout.Buttons>
        <Button
          variant='primary'
          onClick={navigateToNextStep}
          rightIcon={ArrowRightIcon}
        >
          I'm ready
        </Button>
      </CenteredLayout.Buttons>
    </CenteredLayout>
  )
}
